export default [{
        title: 'Inicio',
        route: 'home',
        icon: 'HomeIcon'
    },
    {
        title: 'Página Web',
        icon: 'GlobeIcon',
        children: [{
                title: 'Contactos',
                route: 'messages',
                icon: 'MailIcon'
            },
            {
                title: 'Suscriptores',
                route: 'subscribers',
                icon: 'BellIcon'
            },
            {
                title: 'Blogs',
                route: 'blogs',
                icon: 'LayoutIcon'
            }
        ]
    },
    {
        title: 'Tienda',
        icon: 'ShoppingCartIcon',
        children: [{
                title: 'Productos',
                route: 'products',
                icon: 'ShoppingBagIcon'
            },
            {
                title: 'Ventas',
                route: 'sales',
                icon: 'TrendingUpIcon'
            },
            {
                title: 'Cupones',
                route: 'discountcoupons',
                icon: 'TagIcon'
            },
            {
                title: 'Reseñas',
                route: 'product-comments',
                icon: 'StarIcon'
            },
            {
                /* Unico que despliega sus propios hijos. */
                title: 'Envío y Entrega',
                icon: 'TruckIcon',
                children: [{
                        title: 'Tipos de entrega',
                        route: 'delivery-types',
                        icon: 'MapIcon'
                    },
                    {
                        title: 'Almacenes',
                        route: 'warehouses',
                        icon: 'PackageIcon'
                    }
                ]
            }
        ]
    }
]
